import { Component } from '@angular/core';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { MonitoringQuotaTypesEnum } from '../../../../api/mentions/enum/monitoring-quota-types.enum';
import { QuotaUsageWidgetComponent } from './quota-usage-widget.component';

@Component({
    selector: 'agpr-social-listening-quota-usage-widget',
    templateUrl: './quota-usage-widget.component.html',
    styleUrls: ['./quota-usage-widget.component.scss'],
    standalone: false
})
export class SocialListeningQuotaUsageWidgetComponent extends QuotaUsageWidgetComponent {
    static readonly DIALOG_KEY: string = 'SocialListeningQuotaUsageWidget';

    constructor(coreDialogService: CoreDialogService) {
        super(coreDialogService);
        this.dialogKey = SocialListeningQuotaUsageWidgetComponent.DIALOG_KEY;
        this.key = this.dialogKey;
        this.quotaType = MonitoringQuotaTypesEnum.SOCIAL_LISTENING;
    }
}
